import { Trans } from '@lingui/react/macro';
import { Button } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { Link, useRouteMatch } from 'react-router-dom';
import { useGtm } from 'shared/domains/tracking';
export function AssistantButton() {
    const { url } = useRouteMatch();
    const gtm = useGtm();
    const handleClick = () => {
        gtm.push({ event: 'cta_document_assistant' });
    };
    return (<Button as={Link} to={`${url}/assistant`} size="xs" appearance="primary" onClick={handleClick}>
      <Falcon icon="sparkles"/>
      <Trans comment="Document view - top bar - PLAI button label">Plai</Trans>
    </Button>);
}
